import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0804b487"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-h-full tw-relative tw-overflow-x-hidden sm:tw-min-w-[400px] tw-py-[0px] tw-px-[0px] md:tw-py-[0px] main" }
const _hoisted_2 = {
  style: `
            width: 100%;
            position: relative;
            z-index: 0;
            `,
  class: /*#__PURE__*/_normalizeClass(`tw-my-0 tw-bg-[#fff] tw-py-[55px] xl:tw-px-[60px] tw-pl-[10px] xl:tw-pt-[55px] xl:tw-pb-[55px] tw-pr-[10px] tw-pt-[30px] tw-pb-[30px]`)
}
const _hoisted_3 = {
  style: {"line-height":"22px"},
  class: "title tw-font-semibold tw-text-[#211F58] tw-text-[22px]"
}
const _hoisted_4 = { class: "tw-text-[#211F58] tw-text-[15px]" }
const _hoisted_5 = { class: "tw-w-full content-wrapper" }
const _hoisted_6 = { class: "xl:tw-flex-row xl:tw-gap-[60px] tw-z-[1] tw-relative tw-flex tw-px-[10px] tw-py-[30px] tw-flex-col xl:tw-px-[60px] xl:tw-py-[55px] profile-container" }
const _hoisted_7 = { class: "tw-flex tw-gap-[40px] tw-flex-col" }
const _hoisted_8 = { class: "tw-px-[40px] tw-mt-[40px] tw-flex tw-flex-col tw-gap-[40px] tw-w-full tw-h-[fit-content] companyLogoWrapper" }
const _hoisted_9 = {
  key: 0,
  class: "tw-flex tw-flex-1 tw-items-start tw-px-5 tw-max-w-[519.541px] custom-global-skeleton tw-h-[140px] tw-w-[520px] tw-rounded-[6px] tw-border-[#eff0f1]"
}
const _hoisted_10 = { class: "tw-flex md:tw-gap-[68px] tw-flex-1 tw-flex-col md:tw-flex-row tw-gap-[10px]" }
const _hoisted_11 = { class: "tw-flex tw-flex-col tw-gap-[10px]" }
const _hoisted_12 = { class: "tw-flex tw-flex-col tw-gap-[10px]" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_14 = { class: "tw-pb-[40px] tw-px-[40px] tw-flex tw-flex-col tw-gap-[40px] tw-w-full tw-h-[fit-content] avatarWrapper" }
const _hoisted_15 = {
  key: 0,
  class: "tw-flex tw-flex-1 tw-items-start tw-px-5 tw-max-w-[519.541px] custom-global-skeleton tw-h-[140px] tw-w-[0px] tw-rounded-[6px] tw-border-[#eff0f1]"
}
const _hoisted_16 = { class: "tw-flex md:tw-gap-[68px] tw-flex-col md:tw-flex-row tw-gap-[5px]" }
const _hoisted_17 = { class: "tw-flex tw-flex-col tw-gap-[10px]" }
const _hoisted_18 = { class: "tw-flex tw-flex-col tw-gap-[10px]" }
const _hoisted_19 = { class: "tw-flex tw-gap-[40px] tw-flex-col" }
const _hoisted_20 = { class: "tw-px-[40px] tw-mt-[40px] tw-pb-[40px] tw-flex tw-flex-col tw-gap-[20px] tw-w-full tw-h-[fit-content]" }
const _hoisted_21 = {
  key: 0,
  class: "tw-flex tw-flex-1 tw-items-start tw-px-5 tw-max-w-[519.541px] custom-global-skeleton tw-h-[140px] tw-w-[520px] tw-rounded-[6px] tw-border-[#eff0f1]"
}
const _hoisted_22 = {
  key: 1,
  class: "tw-max-w-lg tw-w-full tw-flex tw-gap-2 tw-flex-wrap"
}
const _hoisted_23 = { class: "tw-max-w-lg tw-w-full tw-flex tw-gap-2 tw-flex-wrap" }
const _hoisted_24 = { class: "tw-max-w-lg tw-w-full tw-flex tw-gap-2 tw-flex-wrap" }
const _hoisted_25 = { class: "tw-order-[1] xl:tw-order-[2] tw-invisible tw-current-hidden" }

import InputField from "@/components/common/inputField1.vue";
import InputWrapper from "@/components/common/inputWrapper1.vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import NoteInfo from "@/components/common/noteInfo.vue";
import FileUploader from "@/components/common/fileUploader.vue";
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import CustomCheckbox from "@/components/common/customCheckBox.vue";
import TextArea from "@/components/common/textArea1.vue";
import BrandPattern from "@/components/prospect/brandPattern/brandPattern4.vue";
import BackgroundComponent from "@/components/common/backgroundComponent.vue";
import Tooltip from "@/components/common/tooltip.vue";
import _ from "underscore";
import ActionButton from "@/components/common/actionButton.vue";
import AddIcon from "@/components/svgs/addIcon.vue";
import UserIcon from "@/components/svgs/userIcon.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import { ref, watch, onMounted, Ref, computed } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import {
  uploadProfileAvatar,
  deleteProfileAvatar,
  getProfileImage,
  uploadProfileLogo,
  deleteProfileLogo,
} from "@/services/org";
import store from "@/store";
import utilities from "@/utils/utilities";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  ACCEPTABLE_AVATAR_FILE_TYPE,
  API_STATUS_LOADING,
} from "@/utils/constants";
import { fileSizeFormat } from "@/utils/dateTimeUtils";
import ImageTracer from "imagetracerjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'profile',
  setup(__props) {

const publicProfile = ref({
  bio: "",
  field1: "Field value",
  field2: "",
});

const brandedForm = ref({
  displayLogoIn: {
    reports: true,
    emails: true,
    doletAdnum: true,
    loremIpsum: false,
  },
  avatarOptions: {
    doletAdnum: true,
    loremIpsum: false,
  },
});

const companyLogo: Ref = ref(null);
const companyLogoRef: Ref = ref(null);
const avatar: Ref = ref(null);
const avatarUploaderRef: Ref = ref(null);

const isFormDirty = ref(false);
const isNoteInfoVisible = ref(true);
const existingPublicProfile = ref({
  bio: "",
  field1: "Field value",
  field2: "",
});
const existingBrandedForm = ref({});
const animationRef: Ref<typeof BrandPattern | null> = ref(null);
const clickboxProfileRef: Ref<HTMLElement | null> = ref(null);
const toastMessage = ref("");
const isToastPositive = ref(true);
const isLoadingLogoImage = ref(true);
const isLoadingAvatarImage = ref(true);
const MAX_LOGO_SIZE = fileSizeFormat(
  process.env.VUE_APP_MAX_LOGO_SIZE || 2097152,
);
const MAX_AVT_SIZE = fileSizeFormat(
  process.env.VUE_APP_MAX_AVT_SIZE || 1048576,
);

const isUpdateApiAvatar = ref(false);
const currentOrg = computed(() => store.state.Org.currentOrg);
const currentOrgProfile = computed<any>(
  () => store.getters["Org/getOrgDetails"],
);
const isLoading = computed(() => store.state.Org.isLoadingOrg);
const profileActions = [
  {
    icon: AddIcon,
    title: "app-settings-organisation-profile-action-a-1",
    titleClass: "tw-max-w-[149px]",
  },
  {
    icon: UserIcon,
    title: "app-settings-organisation-profile-action-a-1",
    titleClass: "tw-w-[149px]",
  },
];

watch(currentOrgProfile, () => {
  publicProfile.value.bio = currentOrgProfile.value.orgBio;
  existingPublicProfile.value = JSON.parse(JSON.stringify(publicProfile.value));
});

function closeNoteInfo() {
  isNoteInfoVisible.value = false;
}
const onLoadingLogoImage = ref(API_STATUS_LOADING.NO_ACTION);
const submitCompanyLogo = async (file) => {
  try {
    isUpdateApiAvatar.value = true;
    if (!file) {
      if (!currentOrg.value.logoImageFileId) return;
      await deleteProfileLogo(currentOrg.value.logoImageFileId);
      store.commit("Org/SET_DELETE_CURRENT_LOGO", currentOrg.value.id);
      alertSuccess(
        getComponentUiText(
          "app-settings-organisation-profile-logo-toast-removed-1",
        ),
      ); // "Avatar is removed successfully"
    } else {
      try {
        onLoadingLogoImage.value = API_STATUS_LOADING.LOADING;
        if (!ACCEPTABLE_AVATAR_FILE_TYPE.includes(file.type)) {
          alertSuccess(
            getComponentUiText(
              "app-component-assessment-modal-assessment-toast-added-fail-1",
            ),
          );
          onLoadingLogoImage.value = API_STATUS_LOADING.ERROR;
          return;
        }
        const formData: FormData = new FormData();
        formData.append("file", file);
        await uploadProfileLogo(formData);
        alertSuccess(
          getComponentUiText(
            "app-settings-organisation-profile-logo-toast-added-1",
          ),
        );
        onLoadingLogoImage.value = API_STATUS_LOADING.SUCCESS;
      } catch (error: any) {
        companyLogo.value = null;
        companyLogoRef.value?.reset();
        if (error && error.data) {
          showErrorAPI(error, Org.orgToProfileImageSave);
        }
        onLoadingLogoImage.value = API_STATUS_LOADING.ERROR;
      }
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.orgDomainVerifyInitiate);
    }
  } finally {
    isUpdateApiAvatar.value = false;
    companyLogoRef.value &&
      typeof companyLogoRef.value.handleClose === "function" &&
      companyLogoRef.value.handleClose();
  }
};
const clickHandler = (e) => {
  if (!clickboxProfileRef.value?.contains(e.target)) {
    animationRef.value && animationRef.value?.reloadToggle();
  }
};

onMounted(() => {
  existingBrandedForm.value = JSON.parse(JSON.stringify(brandedForm.value));
  refreshData(false);
});

watch(
  publicProfile,
  () => {
    isFormDirty.value = !_.isEqual(
      existingPublicProfile.value,
      publicProfile.value,
    );
  },
  { deep: true },
);
const onLoadingAvatarImage = ref(API_STATUS_LOADING.NO_ACTION);
const uploadAvatar = async (file: File | null) => {
  try {
    file && (onLoadingAvatarImage.value = API_STATUS_LOADING.LOADING);
    isUpdateApiAvatar.value = true;

    if (!file) {
      if (!currentOrg.value.avatarImageId) return;
      await deleteProfileAvatar(currentOrg.value.avatarImageId);
      await refreshData(true, false, false);
      alertSuccess(
        getComponentUiText(
          "app-settings-organisation-profile-avatar-toast-removed-1",
        ),
      ); // "Avatar is removed successfully"
      store.commit("Org/SET_URL_AVATAR", null);
      store.commit("Org/SET_DELETE_CURRENT_AVATAR", currentOrg.value.id);
    } else {
      try {
        if (!ACCEPTABLE_AVATAR_FILE_TYPE.includes(file.type)) {
          alertSuccess(
            getComponentUiText(
              "app-component-assessment-modal-assessment-toast-added-fail-1",
            ),
          );
          onLoadingAvatarImage.value = API_STATUS_LOADING.ERROR;
          return;
        }

        const formData: FormData = new FormData();
        formData.append("file", file);

        await uploadProfileAvatar(formData);
        await refreshData(true, false, false);
        alertSuccess(
          getComponentUiText(
            "app-settings-organisation-profile-avatar-toast-added-1",
          ),
        ); // "Avatar is added successfully"

        store.commit("Org/SET_URL_AVATAR", null);
        onLoadingAvatarImage.value = API_STATUS_LOADING.SUCCESS;
      } catch (error: any) {
        onLoadingAvatarImage.value = API_STATUS_LOADING.ERROR;
        avatar.value = null;
        avatarUploaderRef.value?.reset();
        if (error && error.data) {
          showErrorAPI(error, Org.orgToProfileImageSave);
        }
      }
    }
    avatarUploaderRef.value.handleClose();
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.orgDomainVerifyInitiate);
    }
  } finally {
    isUpdateApiAvatar.value = false;
  }
};

const alertSuccess = (text: string) => {
  toastMessage.value = text;
  isToastPositive.value = true;
};
const isCallApi = ref(false);
const handleSaveChanges = async () => {
  try {
    isCallApi.value = true;
    const isSuccess = await store.dispatch("Org/postOrgProfile", {
      bio: publicProfile.value.bio,
    });
    if (isSuccess) {
      existingPublicProfile.value.bio = publicProfile.value.bio;
      isFormDirty.value = false;
    }
  } catch (error) {
    console.log(error);
  } finally {
    isCallApi.value = false;
  }
};

const refreshData = async (
  isRefreshOrg = true,
  isUploadLogo = true,
  isUploadAvatar = true,
) => {
  if (isRefreshOrg) await store.dispatch("Org/refreshOrg");

  if (isUploadLogo) getLogoData();

  if (isUploadAvatar) getAvatarData();

  if (isLoading.value) {
    EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
  }
};

const getLogoData = async () => {
  if (!currentOrg.value?.id) {
    return;
  }
  if (!currentOrg.value?.logoImageFileId) {
    companyLogo.value = null;
    onLoadingLogoImage.value = API_STATUS_LOADING.NO_ACTION;
  } else {
    companyLogo.value = await getImageData(currentOrg.value.logoImageFileId);
    onLoadingLogoImage.value = API_STATUS_LOADING.SUCCESS;
  }
  isLoadingLogoImage.value = false;
};

const getAvatarData = async () => {
  if (!currentOrg.value?.id) {
    return;
  }
  if (!currentOrg?.value.avatarImageId) {
    avatar.value = null;
    onLoadingAvatarImage.value = API_STATUS_LOADING.NO_ACTION;
  } else {
    avatar.value = await getImageData(currentOrg?.value.avatarImageId);
    onLoadingAvatarImage.value = API_STATUS_LOADING.SUCCESS;
  }

  isLoadingAvatarImage.value = false;
};

const getImageData = async (imageId: string) => {
  const imageDetails = await getProfileImage(imageId);
  const filename: string = imageDetails.data.data.fileName;
  const fileType: string = imageDetails.data.data.fileType;
  const base64FileData: string = imageDetails.data.data.file;
  return utilities.base64ToFile(base64FileData, filename, fileType);
};
watch(
  () => currentOrg.value,
  (newValue, oldValue) => {
    if (newValue?.orgId !== oldValue?.orgId) {
      isLoadingLogoImage.value = true;
      isLoadingAvatarImage.value = true;

      refreshData(false);
    }
  },
  { deep: true, immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppBarLayout, null, {
      default: _withCtx(({ activeHierarchy }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(BrandPattern, {
            ref_key: "animationRef",
            ref: animationRef,
            page: "APPBARLAYOUT"
          }, null, 512),
          _createVNode(BackgroundComponent),
          _createVNode(ActivePathWrapper, {
            "active-hierarchy": activeHierarchy,
            "is-button-enable": !isFormDirty.value,
            "is-call-api": isCallApi.value,
            "button-title": _unref(getComponentUiText)('app-common-save-change-button-1'),
            onClickButton: handleSaveChanges
          }, null, 8, ["active-hierarchy", "is-button-enable", "is-call-api", "button-title"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-settings-organisation-profile-title-1")), 1),
            (isNoteInfoVisible.value)
              ? (_openBlock(), _createBlock(NoteInfo, {
                  key: 0,
                  class: "tw-mt-5",
                  onClose: closeNoteInfo
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
                "app-settings-organisation-profile-tip-top-text-1",
              )), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                id: "clickbox-profile",
                ref_key: "clickboxProfileRef",
                ref: clickboxProfileRef,
                class: "tw-flex tw-flex-col tw-gap-[30px] tw-flex-1 tw-order-[2] 2xl:tw-order-[1] tw-max-w-[1182px] tw-z-0 forms !tw-min-w-0",
                onClick: clickHandler
              }, [
                _createVNode(Modal, {
                  visible: true,
                  overlay: false,
                  centered: false,
                  class: "!tw-w-[100%] tw-overflow-hidden !tw-max-h-[unset] brandingWrapper"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ModalHeader, {
                      title: 
                    _unref(getComponentUiText)(
                      'app-settings-organisation-profile-modal-branding-title-1',
                    )
                  ,
                      "hide-close": true
                    }, null, 8, ["title"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(InputWrapper, {
                          label: 
                        _unref(getComponentUiText)(
                          'app-settings-organisation-profile-modal-branding-form-company-logo-label-title-1',
                        )
                      ,
                          required: false,
                          sublabel: 
                        _unref(getComponentUiText)(
                          'app-settings-organisation-profile-modal-branding-form-company-logo-sublabel-title-1',
                        )
                      ,
                          class: "!tw-items-start"
                        }, {
                          default: _withCtx(() => [
                            (isLoadingLogoImage.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                              : _createCommentVNode("", true),
                            (!isLoadingLogoImage.value)
                              ? (_openBlock(), _createBlock(FileUploader, {
                                  key: 1,
                                  ref_key: "companyLogoRef",
                                  ref: companyLogoRef,
                                  file: companyLogo.value,
                                  "onUpdate:file": [
                                    _cache[0] || (_cache[0] = ($event: any) => ((companyLogo).value = $event)),
                                    submitCompanyLogo
                                  ],
                                  type: "logo",
                                  "on-loading": onLoadingLogoImage.value,
                                  "is-profile": true,
                                  guidance: 
                          _unref(getComponentUiText)(
                            'app-settings-organisation-profile-avatar-cropper-formats-3',
                            false,
                            { maxSize: _unref(MAX_LOGO_SIZE) },
                          )
                        ,
                                  crop: true,
                                  "on-crop-submit": true,
                                  "crop-svg": false,
                                  "crop-modal-title": 
                          _unref(getComponentUiText)(
                            'app-settings-organisation-profile-logo-cropper-heading-1',
                          )
                        ,
                                  "font-size-title": 12,
                                  "crop-formats": 
                          _unref(getComponentUiText)(
                            'app-settings-organisation-profile-avatar-cropper-formats-3',
                            false,
                            { maxSize: _unref(MAX_LOGO_SIZE) },
                          )
                        ,
                                  rounded: false,
                                  "use-rectangle-stencil": true,
                                  "is-loading": isUpdateApiAvatar.value,
                                  onOnImageRemove: _cache[1] || (_cache[1] = 
                          () => {
                            // isFormDirty = true;
                            companyLogo.value = null;
                            submitCompanyLogo(null);
                          }
                        )
                                }, null, 8, ["file", "on-loading", "guidance", "crop-modal-title", "crop-formats", "is-loading"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["label", "sublabel"]),
                        _createVNode(InputWrapper, {
                          label: 
                        _unref(getComponentUiText)(
                          'app-settings-organisation-profile-modal-branding-form-display-logo-in-title-1',
                        )
                      ,
                          required: false,
                          class: "!tw-items-start tw-gap-[10px] md:tw-gap-[50px] lg:tw-gap-[169px] xl:tw-gap-[252px] !tw-justify-start tw-hidden"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, [
                                _createVNode(CustomCheckbox, {
                                  "is-checked": brandedForm.value.displayLogoIn.reports,
                                  title: 
                              _unref(getComponentUiText)(
                                'app-settings-organisation-profile-display-logo-in-checkbox-title-1',
                              )
                            ,
                                  size: "20px",
                                  class: "!tw-mb-[0px]",
                                  "onUpdate:value": _cache[2] || (_cache[2] = 
                              (value) =>
                                (brandedForm.value.displayLogoIn.reports = value)
                            )
                                }, null, 8, ["is-checked", "title"]),
                                _createVNode(CustomCheckbox, {
                                  "is-checked": brandedForm.value.displayLogoIn.doletAdnum,
                                  title: 
                              _unref(getComponentUiText)(
                                'app-settings-organisation-profile-display-logo-in-checkbox-title-2',
                              )
                            ,
                                  size: "20px",
                                  class: "!tw-mb-[0px]",
                                  "onUpdate:value": _cache[3] || (_cache[3] = 
                              (value) =>
                                (brandedForm.value.displayLogoIn.doletAdnum = value)
                            )
                                }, null, 8, ["is-checked", "title"])
                              ]),
                              _createElementVNode("span", _hoisted_12, [
                                _createVNode(CustomCheckbox, {
                                  "is-checked": brandedForm.value.displayLogoIn.emails,
                                  title: 
                              _unref(getComponentUiText)(
                                'app-settings-organisation-profile-display-logo-in-checkbox-title-3',
                              )
                            ,
                                  size: "20px",
                                  class: "!tw-mb-[0px]",
                                  "onUpdate:value": _cache[4] || (_cache[4] = 
                              (value) =>
                                (brandedForm.value.displayLogoIn.emails = value)
                            )
                                }, null, 8, ["is-checked", "title"]),
                                _createVNode(CustomCheckbox, {
                                  "is-checked": brandedForm.value.displayLogoIn.loremIpsum,
                                  title: 
                              _unref(getComponentUiText)(
                                'app-settings-organisation-profile-display-logo-in-checkbox-title-4',
                              )
                            ,
                                  size: "20px",
                                  class: "!tw-mb-[0px]",
                                  "onUpdate:value": _cache[5] || (_cache[5] = 
                              (value) =>
                                (brandedForm.value.displayLogoIn.loremIpsum = value)
                            )
                                }, null, 8, ["is-checked", "title"])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(InputWrapper, {
                          label: 
                        _unref(getComponentUiText)(
                          'app-settings-organisation-profile-modal-branding-form-avatar-label-title-1',
                        )
                      ,
                          required: false,
                          sublabel: 
                        _unref(getComponentUiText)(
                          'app-settings-organisation-profile-modal-branding-form-avatar-sublabel-title-1',
                        )
                      ,
                          class: "!tw-items-start"
                        }, {
                          default: _withCtx(() => [
                            (isLoadingAvatarImage.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                              : _createCommentVNode("", true),
                            (!isLoadingAvatarImage.value)
                              ? (_openBlock(), _createBlock(FileUploader, {
                                  key: 1,
                                  ref_key: "avatarUploaderRef",
                                  ref: avatarUploaderRef,
                                  file: avatar.value,
                                  "onUpdate:file": [
                                    _cache[6] || (_cache[6] = ($event: any) => ((avatar).value = $event)),
                                    uploadAvatar
                                  ],
                                  "on-loading": onLoadingAvatarImage.value,
                                  type: "avatar",
                                  "font-size-title": 12,
                                  "is-profile": true,
                                  guidance: 
                          _unref(getComponentUiText)(
                            'app-settings-organisation-profile-avatar-cropper-formats-1',
                            false,
                            { maxSize: _unref(MAX_AVT_SIZE) },
                          )
                        ,
                                  crop: true,
                                  "crop-svg": false,
                                  "crop-modal-title": 
                          _unref(getComponentUiText)(
                            'app-settings-organisation-profile-avatar-cropper-heading-1',
                          )
                        ,
                                  "crop-formats": 
                          _unref(getComponentUiText)(
                            'app-settings-organisation-profile-avatar-cropper-formats-1',
                            false,
                            { maxSize: _unref(MAX_AVT_SIZE) },
                          )
                        ,
                                  rounded: true,
                                  "is-loading": isUpdateApiAvatar.value,
                                  onOnImageRemove: _cache[7] || (_cache[7] = 
                          () => {
                            avatar.value = null;
                            uploadAvatar(null);
                          }
                        )
                                }, null, 8, ["file", "on-loading", "guidance", "crop-modal-title", "crop-formats", "is-loading"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["label", "sublabel"]),
                        _createVNode(InputWrapper, {
                          label: 
                        _unref(getComponentUiText)(
                          'app-settings-organisation-profile-modal-branding-form-avatar-options-label-title-1',
                        )
                      ,
                          required: false,
                          class: "!tw-items-start tw-gap-[10px] md:tw-flex-col lg:tw-flex-row lg:tw-gap-[169px] xl:tw-gap-[252px] !tw-justify-start tw-hidden"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, [
                                _createVNode(CustomCheckbox, {
                                  "is-checked": brandedForm.value.avatarOptions.doletAdnum,
                                  title: 
                              _unref(getComponentUiText)(
                                'app-settings-organisation-profile-avatar-options-checkbox-title-1',
                              )
                            ,
                                  size: "20px",
                                  class: "!tw-mb-[0px]",
                                  "onUpdate:value": _cache[8] || (_cache[8] = 
                              (value) =>
                                (brandedForm.value.avatarOptions.doletAdnum = value)
                            )
                                }, null, 8, ["is-checked", "title"])
                              ]),
                              _createElementVNode("span", _hoisted_18, [
                                _createVNode(CustomCheckbox, {
                                  "is-checked": brandedForm.value.avatarOptions.loremIpsum,
                                  title: 
                              _unref(getComponentUiText)(
                                'app-settings-organisation-profile-avatar-options-checkbox-title-2',
                              )
                            ,
                                  size: "20px",
                                  class: "tw-mb-[0px]",
                                  "onUpdate:value": _cache[9] || (_cache[9] = 
                              (value) =>
                                (brandedForm.value.avatarOptions.loremIpsum = value)
                            )
                                }, null, 8, ["is-checked", "title"])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(Modal, {
                  visible: true,
                  overlay: false,
                  centered: false,
                  class: "!tw-w-[100%] publicProfileWrapper"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ModalHeader, {
                      title: 
                    _unref(getComponentUiText)(
                      'app-settings-organisation-profile-modal-public-profile-title-1',
                    )
                  ,
                      "hide-close": true
                    }, null, 8, ["title"]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(InputWrapper, {
                          label: 
                        _unref(getComponentUiText)(
                          'app-settings-organisation-profile-modal-branding-form-organisation-bio-label-title-1',
                        )
                      ,
                          required: false,
                          sublabel: 
                        _unref(getComponentUiText)(
                          'app-settings-organisation-profile-modal-branding-form-organisation-bio-sublabel-title-1',
                        )
                      ,
                          class: "!tw-items-start"
                        }, {
                          default: _withCtx(() => [
                            (isLoadingLogoImage.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                              : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                  _createVNode(TextArea, {
                                    id: "bio",
                                    value: publicProfile.value.bio,
                                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((publicProfile.value.bio) = $event)),
                                    class: "tw-h-[138px]",
                                    placeholder: 
                            _unref(getComponentUiText)(
                              'app-settings-organisation-profile-modal-branding-form-organisation-bio-input-placeholder-title-1',
                            )
                          ,
                                    "no-resize": true,
                                    name: "bio"
                                  }, null, 8, ["value", "placeholder"])
                                ]))
                          ]),
                          _: 1
                        }, 8, ["label", "sublabel"]),
                        _createVNode(InputWrapper, {
                          label: 
                        _unref(getComponentUiText)(
                          'app-settings-organisation-profile-modal-branding-form-field-label-title-1',
                        )
                      ,
                          required: false,
                          class: "tw-hidden"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_23, [
                              _createVNode(InputField, {
                                id: "field1",
                                value: publicProfile.value.field1,
                                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((publicProfile.value.field1) = $event)),
                                type: "text",
                                name: "field1",
                                placeholder: 
                            _unref(getComponentUiText)(
                              'app-settings-organisation-profile-modal-branding-form-field-input-placeholder-title-1',
                            )
                          ,
                                "class-style": 'tw-gap-2.5 tw-border tw-text-[#231F20] tw-text-[13px] tw-px-5 tw-pt-[17.5px] tw-pb-[17px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] background-gray'
                              }, null, 8, ["value", "placeholder"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(InputWrapper, {
                          label: 
                        _unref(getComponentUiText)(
                          'app-settings-organisation-profile-modal-branding-form-field-label-title-1',
                        )
                      ,
                          required: false,
                          class: "tw-hidden"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_24, [
                              _createVNode(InputField, {
                                id: "field2",
                                value: publicProfile.value.field2,
                                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((publicProfile.value.field2) = $event)),
                                type: "text",
                                name: "field2",
                                placeholder: 
                            _unref(getComponentUiText)(
                              'app-settings-organisation-profile-modal-branding-form-field-input-placeholder-title-1',
                            )
                          ,
                                "class-style": 'tw-ml-[9px] tw-gap-2.5 tw-border tw-text-[#231F20] tw-text-[13px] tw-px-5 tw-pt-[17.5px] tw-pb-[17px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] background-gray'
                              }, null, 8, ["value", "placeholder"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ], 512),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(ActionButton, {
                  "profile-actions": profileActions,
                  class: "tw-max-w-[241px] tw-z-[-1]"
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(Tooltip, {
      id: "profile-tooltip",
      variant: isToastPositive.value ? 'success' : 'danger',
      show: !!toastMessage.value,
      onClose: _cache[13] || (_cache[13] = ($event: any) => (toastMessage.value = ''))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(toastMessage.value), 1)
      ]),
      _: 1
    }, 8, ["variant", "show"])
  ], 64))
}
}

})